<template>
<div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="configEditLabel">{{this.scriptitle}}</h5>

          <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
        </div>
        <div class="modal-body">
          <form id="processscripts" method="post">
            <div class="form-group" v-for="field in scriptfields">
              <div v-if="field[0].startsWith('dataset')">
                <label>{{field[1]}}</label>
                <select class="form-control input-lg" :name="field[0]">
                  <option>Select a dataset</option>
                  <option v-for='(data, index) in datasets' :value="data">{{data}}</option>
                </select>
              </div>
              <div v-else-if="field[0].startsWith('prospect')">
                <label>{{field[1]}}</label>
                <select class="form-control input-lg" :name="field[0]">
                  <option>Select a prospect list</option>
                  <option v-for='(data, index) in prospects' :value="data">{{data}}</option>
                </select>
              </div>
              <!-- start condition for pipes -->

              <div v-else-if="field[1].includes('|')">
                <label>{{getPipedDescription(field[1])}}</label>
                <select class="form-control input-lg" :name="field[0]">
                  <option>Select a value</option>
                  <option v-for='(data, index) in getPipedArray(field[1])' :value="data">{{data}}</option>
                </select>
              </div>

              <!-- end condition for pipes -->
              <!-- start condition for input -->

              <div v-else-if="field[1].includes('file')">
                <label>{{field[1]}}</label>
                <input type="text" @input="validateInput" class="form-control input-lg" :name="field[0]" />
              </div>

              <!-- end condition for pipes -->


              <!-- start baselines -->

              <div v-else-if="field[0].startsWith('baselines')">
                <label>{{field[1]}}</label>
                <select class="form-control input-lg" :name="field[0]">
                  <option>Select a baseline</option>
                  <option v-for='(data, index) in baselines' :value="data" :key="index">{{data}}</option>
                </select>
              </div>

              <!-- end baselines -->


              <div v-else>
                <label>{{field[1]}}</label>
                <input class="form-control input-lg" :name="field[0]" />
              </div>
            </div>
            <div class="form-group d-none">
                <button class="btn btn-default">Results</button>
            </div>
            <div class="form-group">
              <button type="button" class="btn btn-light" @click="$emit('closeModal')">Cancel</button>
              <button type="button" class="btn btn-primary" @click="onSubmit">Submit</button>
            </div>
          </form>
        </div>
      </div>
</template>
<script>
import axios from 'axios';
export default {
   name: 'ModalDeleteDataset',
    props: {
      passedModalData: '',
    },
    data() {
      return {
        scriptitle: 'Configuration Script',
        scriptfields: [],
        datasets: [],
        prospects: [],
        baselines: []
      }
    },
    methods: {
      onSubmit() {
        let scriptsform = document.forms["processscripts"];
        let formData = new FormData(scriptsform);
        formData.append('script_name', this.passedModalData);
        axios({
          method : 'POST',
          url : '/script_run',
          data:formData,
        }).then(
              (response) => {
                console.log('SCRIPT RUN response: '+JSON.stringify(response.data));
                this.$emit('closeModal');
          })
          .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        });
      },
      validateInput(event) {
        event.target.value = event.target.value.replace(/[^a-zA-Z0-9_-]/g, '');
      },
      returnUpdatedList() {
        axios({
          method : 'POST',
          url : '/list_datasets',
          data:'',
        }).then(
          (response) => {
            this.datasets = processDatasets(response.data);
            this.prospects = processProspects(response.data);
            console.log('datasets list? '+JSON.stringify(this.datasets));
          }
        )
          .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
      },
      getBaselines() {
        axios({
          method : 'POST',
          url : '/list_baselines',
          data:'',
        }).then(
          (response) => {
            this.baselines = response.data;
            console.log('baselines '+JSON.stringify(this.baselines));
          }
        )
          .catch(error => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
        });
      },
      getPipedDescription(value) {
        return value.split('#')[0];
      },
      getPipedArray(value) {
        var newval = value.split('#')[1];
        return newval.split('|');
      }
    },
    mounted() {
      // console.log('mounted config scripts '+this.passedModalData);
      let formData = new FormData();
      formData.append('script_name', this.passedModalData);
      axios({
        method : 'POST',
        url : '/script_parameters',
        data:formData,
      }).then(
            (response) => {
              this.scriptfields = response.data.params;
              this.scriptitle = response.data.title;
			        console.log('SCRIPT PARAMETERS response: '+JSON.stringify(this.scriptfields));
        })
        .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
      });
      this.returnUpdatedList();
      this.getBaselines();
    }
}
function processDatasets(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect') || b[i].includes('baseline'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
}
function processProspects(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || !b[i].includes('prospect'))
          continue;
            iH.push(b[i]);
      };
      return iH;
}
</script>